<template>
    <BasicTile class="rectangle-tile" @click="tileClicked()">
        <slot name="badge"></slot>
        <div class="rectangle-tile__container w-100">
            <div class="rectangle-tile__item-1">
                <slot name="icon"></slot>
            </div>
            <div class="rectangle-tile__item-2 d-flex flex-column justify-center h-100">
                <slot name="details"></slot>
                <div v-if="$slots.actions" class="rectangle-tile__item-3">
                    <slot name="actions"></slot>
                </div>
            </div>
            <div v-if="$slots['append-right']" class="rectangle-tile__item-4">
                <slot name="append-right"></slot>
            </div>
        </div>
        <div v-if="$slots['append-bottom']" class="rectangle-tile__item-5">
            <slot name="append-bottom"></slot>
        </div>
    </BasicTile>
</template>



<script setup>
import BasicTile from '@/components/Tiles/Basic-Tile.vue';

const emit = defineEmits(['click']);

const props = defineProps({
    id: String,
    offer: Object,
});

const tileClicked = () => {
    emit('click');
}

</script>